import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";
import { useWatch } from "react-hook-form";

import { AgreementProductsAutocomplete, AgreementsAutocomplete, Form } from "@shared/components";

export const MapIntegrationPlanListFilters = React.memo(() => {
  const translate = useTranslate();
  const agreement = useWatch({ name: "agreement" });

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("subscription_mapintegrationplan_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("subscription_mapintegrationplan_admin.filters.agreement")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AgreementProductsAutocomplete
          name="product"
          label={translate("subscription_mapintegrationplan_admin.filters.product")}
          agreement={agreement}
          disabled={!agreement}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="plan_type"
          label={translate("subscription_mapintegrationplan_admin.filters.plan_type")}
          options={[
            { value: "club", label: "Clube" },
            { value: "book", label: "Livros" },
            { value: "magazine", label: "Revistas" },
          ]}
        />
      </Grid>
    </Grid>
  );
});
